import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import CustomizerContext from '../../_helper/Customizer';

const SidebarIcon = () => {
  const { layoutURL } = useContext(CustomizerContext);
  return (
    <div className="logo-icon-wrapper">
      <Link to="/">
        <img
          className="img-fluid"
          src={`/logo-close.png`}
          alt=""
        />
      </Link>
    </div>
  );
};

export default SidebarIcon;